import React, { useState, useEffect, useRef } from 'react'
import AlertDialog from '../../../conversations/components/alertDialog'
import axios from '../../../../../data/http/axios'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Icons from '~/Common-Objects/UI/Icons/index'
import SmallLineGraph from '~/Common-Objects/UI/Graphs/SmallLineGraph/SmallLineGraph'
import { humanizeBytes } from './shared'

export default function AddVideo({ CampaignId, onAdded = () => {}, onClose = () => {} }) {
    const [uploading, setUploading] = useState(false)
    const [file, setFile] = useState(null)
    const [err, setErr] = useState(null)
    const [progress, setProgress] = useState(0)
    const inputRef = useRef()

    const handleFileChange = (event) => {
        setFile(event.target.files[0])
    }

    const handleDrop = (event) => {
        event.preventDefault()
        setFile(event.dataTransfer.files[0])
    }

    const handleDragOver = (event) => {
        event.preventDefault()
    }

    function upload() {
        setUploading(true)
        const data = new FormData()
        try {
            data.append('file', file)
            data.append('friendlyName', file.name)
            data.append('CampaignId', CampaignId)
        } catch (e) {
            console.log(e)
            return { error: true }
        }

        return axios
            .post('/video', data, {
                onUploadProgress: (event) => setProgress(Math.round((event.loaded / event.total) * 100))
            })
            .then((res) => {
                setUploading(false)
                onAdded(res.data)
            })
            .catch((err) => {
                console.log(err)
                setErr(err.data.error)
                return { error: true }
            })
    }

    useEffect(() => {
        if (!file) return setErr(null)
        if (file.size > 200000000) {
            setErr('The file exceeds 200MB. Please select a smaller video.')
        } else if (file.type !== 'video/mp4' && file.type !== 'video/mov') {
            setErr('The file must be an MP4 or MOV file.')
        } else {
            setErr(null)
        }
    }, [file])

    let outerStyle = {
        border: '2px dashed var(--neutral-400)',
        padding: '20px',
        textAlign: 'center',
        borderRadius: 12
    }

    if (file) {
        outerStyle = {}
    }

    return (
        <AlertDialog
            open={true}
            title='Add video'
            description='Larger files may take a few minutes to upload.'
            ctaText='Upload video'
            ctaVariant='primary'
            onCtaClick={upload}
            submitting={uploading}
            onClose={onClose}
            disabled={!!err}
        >
            <div onDrop={handleDrop} onDragOver={handleDragOver} style={outerStyle}>
                <input
                    ref={inputRef}
                    type='file'
                    accept='video/mp4,video/mov'
                    onChange={handleFileChange}
                    style={{ display: 'none' }}
                    id='fileInput'
                />
                {!file && (
                    <label
                        htmlFor='fileInput'
                        style={{
                            cursor: 'pointer',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}
                    >
                        <div
                            className='mar-b20'
                            style={{ backgroundColor: 'var(--indigo-50)', borderRadius: 8, padding: 8 }}
                        >
                            <Icons icon='video' style={{ height: 20, width: 20 }} />
                        </div>
                        <span className='mar-b5' style={{ fontSize: 16 }}>
                            <a style={{ textDecoration: 'underline' }}>Click to select</a> or drag and drop
                        </span>
                        <div style={{ color: 'var(--neutral-700)', fontSize: 12 }}>
                            MP4 or MOV file. Maximum size 200MB
                        </div>
                    </label>
                )}
                {!!file && (
                    <div
                        className='quickFlex'
                        style={{
                            alignItems: 'center',
                            border: '1px solid var(--neutral-300)',
                            borderRadius: 8,
                            padding: '12px 16px',
                            gap: 16
                        }}
                    >
                        <Icons icon='video' color='black' outerStyle={{ height: 20 }} />
                        <div style={{ display: 'block', flexGrow: 1, textAlign: 'left' }}>
                            <div>{file.name}</div>
                            <div style={{ color: 'var(--neutral-800)' }}>{humanizeBytes(file.size)}</div>
                        </div>
                        {!uploading && (
                            <Button
                                className='button-red-ghost button-sml'
                                iconLeft={<Icons icon='bin' color='var(--red-600)' />}
                                onClick={() => {
                                    inputRef.current.value = ''
                                    setFile(null)
                                }}
                            >
                                Remove
                            </Button>
                        )}
                        {uploading && (
                            <div style={{ maxWidth: 150 }}>
                                <SmallLineGraph
                                    hideText={true}
                                    color='var(--indigo-800)'
                                    width='100%'
                                    height='5'
                                    val1={progress}
                                    val2={100}
                                />
                            </div>
                        )}
                    </div>
                )}
            </div>
            {!!err && (
                <div className='quickFlex' style={{ marginTop: 5 }}>
                    <Icons
                        icon='warning'
                        color='var(--red-800)'
                        style={{ width: 20, height: 20 }}
                        className='mar-r10'
                    />
                    <div style={{ flexGrow: 1, color: 'var(--red-800)' }}>{err}</div>
                </div>
            )}
        </AlertDialog>
    )
}
